<span id="version" *ngIf="appInfo">
  {{'APP_VERSION' | translate}}: {{appInfo.appVersion}}<br/>
  {{'APP_ENV' | translate}}: {{appInfo.environment}}
</span>
